// extracted by mini-css-extract-plugin
export var menuIcon = "_tt-0";
export var menuIconInline = "_tt-1";